import React from 'react';
import { Users, Sticker, Download, Star } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Users className="w-5 h-5 text-sky-400" data-id="element-194" />,
    text: '+1.500 argentinos'
  }, {
    icon: <Sticker className="w-5 h-5 text-sky-400" data-id="element-195" />,
    text: '7.000+ stickers'
  }, {
    icon: <Download className="w-5 h-5 text-sky-400" data-id="element-196" />,
    text: 'Descarga inmediata'
  }, {
    icon: <Star className="w-5 h-5 text-sky-400 fill-sky-400" data-id="element-197" />,
    text: '4.9/5 calificación ⭐'
  }];
  return <div className="bg-zinc-900 border-y border-sky-900/40 py-6" data-id="element-198">
      <div className="container mx-auto px-4" data-id="element-199">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center max-w-5xl mx-auto" data-id="element-200">
          {stats.map((stat, i) => <div key={i} className="flex items-center gap-2 font-medium text-zinc-100" data-id="element-201">
              {stat.icon}
              <span data-id="element-202">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}